<div class="select-document">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.admin.tasks.select-document-dialog.title"></sc-dictionary-label>
    </h2>

    <div class="dialog-content">

      <sc-padding>

        <div class="table-container">
          <table class="w-100 mat-table-selection" mat-table [dataSource]="dataSource">
            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
              <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell mat-header *matHeaderCellDef>
                <sc-dictionary-label dictionaryKey="tmc.admin.tasks.select-document-dialog.table.column.name"></sc-dictionary-label>
              </th>
              <td mat-cell *matCellDef="let document">
                <sc-dictionary-label [dictionaryKey]="document.nameDictionaryKey"></sc-dictionary-label>
               </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let document; columns: columnsToDisplay" [ngClass]="getRowStyles(document)"
              (click)="toggleSelection(document)"></tr>

            <tr [class.hide]="!showNoData()" mat-footer-row *matFooterRowDef="['noRecord']"></tr>

          </table>
        </div>

      </sc-padding>

    </div>

    <div>
      <sc-padding>
        <sc-flex>
          <sc-content-spacer grow></sc-content-spacer>
          <sc-cancel-button (click)="cancel()"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-confirm-button primary (click)="selectDocument()"></sc-confirm-button>
        </sc-flex>
      </sc-padding>
    </div>
  </div>
</div>
